module.exports = __webpack_public_path__ + "img/Buprenorphine (BUP).95722368.png";